import { useContext } from 'react';
import { LoggerContext } from '@gplibraries/react/context';
import { Logger } from '@gplibraries/react/utils';
export function useLogger() {
    return useContext(LoggerContext);
}
